import type { StorageSerializer } from "./storage"
import { cookieStorageStrategy, useStorage } from "./storage"

const stringSerializer: StorageSerializer<string> = {
  to: (value) => String(value),
  from: (value) => value,
}

const numberSerializer: StorageSerializer<number> = {
  to: (value) => String(value),
  from: (value) => parseFloat(value),
}

/**
 * Like useState, but persists the state to a cookie.
 * See `useLocalState` to store values in localStorage instead.
 *
 * @param name The unique name of the cookie
 * @param defaultValue An optional default value
 */
export const useCookie: {
  (name: string): [string | undefined, (value: string | undefined) => void]
  <T>(name: string, defaultValue: T): [T, (value: T) => void]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} = (name: string, defaultValue?: any) => {
  const serializer = typeof defaultValue === "number" ? numberSerializer : stringSerializer

  return useStorage(cookieStorageStrategy, name, defaultValue, { serializer })
}
